import React from "react";
import "../../assets/css/Contact.css";
import { Helmet } from "react-helmet-async";

function Contact() {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Contact Apexo Industrial for industrial chemicals, enzymes and equipment supply across India."
        />
      </Helmet>
      {/* ================= HERO ================= */}
      <section className="contact-hero">
        <div className="container text-center">
          <h1>Contact Us</h1>
          <p>Connect with Apexo Industrial for reliable solutions</p>
        </div>
      </section>

      {/* ================= CONTACT INFO ================= */}
      <section className="contact-section">
        <div className="container">
          <div className="row justify-content-center g-4">
            {/* Address */}
            <div className="col-lg-4 col-md-6 d-flex">
              <div className="contact-card w-100">
                <i className="bi bi-geo-alt-fill"></i>
                <h5>Our Address</h5>
                <p>
                  <strong>Apexo Industrial</strong>
                  <br />
                  18-A, "Shraddha Sankul",
                  <br />
                  6th Lane, Near IDBI Bank,
                  <br />
                  Jaysingpur 416101,
                  <br />
                  Dist. Kolhapur (MH), India
                </p>
              </div>
            </div>

            {/* Phone */}
            <div className="col-lg-4 col-md-6 d-flex">
              <div className="contact-card w-100">
                <i className="bi bi-telephone-fill"></i>
                <h5>Call Us</h5>
                <p>+91 9359466302</p>
              </div>
            </div>

            {/* Email */}
            <div className="col-lg-4 col-md-6 d-flex">
              <div className="contact-card w-100">
                <i className="bi bi-envelope-fill"></i>
                <h5>Email Us</h5>
                <p>Email 1: corporate@apexoindustrial.com</p>
                <p>Email 2: sales@apexoindustrial.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
